import { cn } from '@/lib/utils'

export const p = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p
    className={cn('leading-relaxed [&:not(:first-child)]:mt-4', className)}
    {...props}
  />
)
